import React, { useState, useEffect } from "react";
import { withTitle } from "../../HoC";

import { Map } from "../../Components/Map/Map";

import style from "./mainpage.module.scss";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";

import { fetchStores } from "./actions";
import { StoreCard } from "../../Components/StoreCard/StoreCard";
import { translate } from "../../translations/translate";
import { Header } from "../../Components/Header/Header";

export interface IUser {
  exp: number;
  iat: number;
  uid: string;
  typ: number;
}

const MainPage = ({ actions, stores, history }) => {
  const [ overlayVisible, setOverlay ] = useState(false);
  const [ storeId, setStoreId ] = useState<any>(1);
  useEffect(() => {
    actions.fetchStores();
  }, []);

  const classNames = (data) => `${ data ? style["open"] : ""}`;

  const onMarkerClick = (e) => {
    setStoreId(e.uuid);
    setOverlay(true);
  };

  return (<div className={style["wrapper"]}>
    <div className={style["header-wrapper"]}>
      <Header withProfile />
    </div>
    <div className={style["map"]}>
      <Map stores={stores} onClick={onMarkerClick} />
    </div>
    <div className={`${style["overlay"]} ${classNames(overlayVisible)}`}>
      {overlayVisible ? (<StoreCard history={history} onClose={() => setOverlay(false)} storeId={storeId} />) : null}
    </div>
  </div>);
};

const mapStateToProps = (state) => ({
  stores: state.storesReducer.stores,
});

const mapDispatchToProps = (dispatch) =>  ({
  actions : bindActionCreators({
    fetchStores,
  }, dispatch),
});

export default compose(
  withTitle(translate("map")),
  connect(mapStateToProps, mapDispatchToProps),
)(MainPage);
